<div class="modal-container">
  <h2 mat-dialog-title>
    <mat-icon>analytics</mat-icon>
    Generate Site Report
    <button mat-icon-button 
            (click)="toggleFullScreen()" 
            class="fullscreen-button"
            [matTooltip]="isFullScreen ? 'Exit Full Screen' : 'Full Screen'">
      <mat-icon>{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>
  </h2>
  
  <mat-dialog-content>
    <!-- Date Selection Form -->
    <div *ngIf="!showDashboard">
      <div class="site-info">
        <p><strong>Site:</strong> {{ data.siteName }}</p>
      </div>
      
      <form [formGroup]="reportForm" class="report-form">
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>From Date</mat-label>
            <input matInput type="date" formControlName="fromDate" required>
            <mat-error *ngIf="reportForm.get('fromDate')?.hasError('required')">
              From date is required
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>To Date</mat-label>
            <input matInput type="date" formControlName="toDate" required>
            <mat-error *ngIf="reportForm.get('toDate')?.hasError('required')">
              To date is required
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>

    <!-- Dashboard Display -->
    <div *ngIf="showDashboard" class="dashboard-container">
      <app-site-report-dashboard 
        [eventData]="currentReportData" 
        [siteName]="currentSiteName">
      </app-site-report-dashboard>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    
    <!-- Generate Report Button -->
    <button mat-raised-button 
            color="primary" 
            (click)="onGenerateReport()"
            [disabled]="!reportForm.valid || isLoading"
            *ngIf="!showDashboard">
      <mat-icon>download</mat-icon>
      Generate Report
    </button>
    
    <!-- Back to Form Button -->
    <button mat-raised-button 
            color="accent" 
            (click)="closeDashboard()"
            *ngIf="showDashboard">
      <mat-icon>arrow_back</mat-icon>
      Back to Form
    </button>
  </mat-dialog-actions>
</div>
